var _path, _path2, _path3, _path4, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 36C25.9729 36 27.1668 34.8061 27.1668 33.3333C27.1668 31.8606 25.9729 30.6667 24.5002 30.6667C23.0274 30.6667 21.8335 31.8606 21.8335 33.3333C21.8335 34.8061 23.0274 36 24.5002 36Z",
    fill: "#FFE600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 36C25.9729 36 27.1668 34.8061 27.1668 33.3333C27.1668 31.8606 25.9729 30.6667 24.5002 30.6667C23.0274 30.6667 21.8335 31.8606 21.8335 33.3333C21.8335 34.8061 23.0274 36 24.5002 36Z",
    fill: "url(#paint0_linear_7070_113531)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 12C23.0335 12 21.8335 13.2 21.8335 14.6667V25.3333C21.8335 26.8 23.0335 28 24.5002 28C25.9668 28 27.1668 26.8 27.1668 25.3333V14.6667C27.1668 13.2 25.9668 12 24.5002 12Z",
    fill: "#FFE600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 12C23.0335 12 21.8335 13.2 21.8335 14.6667V25.3333C21.8335 26.8 23.0335 28 24.5002 28C25.9668 28 27.1668 26.8 27.1668 25.3333V14.6667C27.1668 13.2 25.9668 12 24.5002 12Z",
    fill: "url(#paint1_linear_7070_113531)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "#FFE600",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "url(#paint2_linear_7070_113531)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7070_113531",
    x1: 21.897,
    y1: 10.0001,
    x2: 28.7795,
    y2: 11.9393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE24A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7070_113531",
    x1: 21.897,
    y1: 10.0001,
    x2: 28.7795,
    y2: 11.9393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE24A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7070_113531",
    x1: 1.07145,
    y1: -3.99997,
    x2: 27.6746,
    y2: 27.7341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE24A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB274"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning3);
export default __webpack_public_path__ + "static/media/warning-3.c7dc412742edd4f484ee24c93d02b6b9.svg";
export { ForwardRef as ReactComponent };